import { snackbar } from "../../../../utils/general/generalUtils"
import { postClientProtected } from "../../clients/clients"
import { INSTALLER_FEEDBACK } from "../../urls/private"

interface IInstallerFeedbackHook {
    postResponse: (
        question: string,
        rating: number,
        comment: string
    ) => Promise<void>
}

/**
 * Provides functions and loigc for posting a DNO response
 * to an escalated LCT application.
 * @returns {IInstallerFeedbackHook} - loading and error states.
 */
const useInstallerFeedback = (): IInstallerFeedbackHook => {
    const postResponse = async (
        question: string,
        rating: number,
        comment: string
    ): Promise<void> => {
        try {
            // Build response body
            const body = {
                question,
                rating,
                comment,
                epochTime: Date.now(),
            }
            await postClientProtected(INSTALLER_FEEDBACK, body)
        } catch (err) {
            snackbar("Unable to submit feedback at this time", "warning")
        }
    }

    return {
        postResponse,
    }
}

export default useInstallerFeedback
